import lightGray from './light-gray';
import greyBorder from './grey-border';
import brandedSolid from './branded-solid';
import colorBorder from './color-border';
import colorBorderBlackText from './color-border-black-text';
import colorText from './color-text';

export default {
  lightGray,
  greyBorder,
  brandedSolid,
  colorBorder,
  colorBorderBlackText,
  colorText,
};
